import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~500px (past hero)
      setVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-356">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] px-3 py-2.5 flex items-center gap-3" data-id="element-357">
          <div className="flex flex-col leading-tight" data-id="element-358">
            <span className="text-[10px] text-gray-500 font-medium uppercase tracking-wider" data-id="element-359">
              Desde
            </span>
            <span className="text-base font-black text-brand-900" data-id="element-360">
              $19.990{' '}
              <span className="text-[10px] text-gray-400 line-through font-medium" data-id="element-361">
                $49.990
              </span>
            </span>
          </div>
          <button onClick={scrollToPricing} className="flex-1 bg-accent-500 hover:bg-accent-600 text-white font-black text-sm py-3 px-4 rounded-xl shadow-[0_4px_14px_rgb(239,68,68,0.4)] flex items-center justify-center gap-1.5 active:scale-95 transition-transform" data-id="element-362">
            COMPRAR AHORA
            <ArrowRight className="w-4 h-4" data-id="element-363" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}